import en from './en/en.json';
import contact_en from './en/contact-en.json';
import legal_en from './en/legal-en.json';
import faq_en from './en/faq-en';
import cookiesInfo_en from './en/cookies-info-en.json';
import agb_en from './en/agb-en.json';
import privacy_en from './en/privacy-en.json';
import about_us_en from './en/about-us-en.json';

import de from './de/de.json';
import contact_de from './de/contact-de.json';
import legal_de from './de/legal-de.json';
import faq_de from './de/faq-de';
import cookiesInfo_de from './de/cookies-info-de.json';
import agb_de from './de/agb-de.json';
import privacy_de from './de/privacy-de.json';
import about_us_de from './de/about-us-de.json';

import fr from './fr/fr.json';
import privacy_fr from './fr/privacy-fr.json';

import es from './es/es.json';
import contact_es from './es/contact-es.json';
import legal_es from './es/legal-es.json';
import faq_es from './es/faq-es';
import cookiesInfo_es from './es/cookies-info-es.json';

import zh from './zh/zh.json';

import nl from './nl/nl.json';
import contact_nl from './nl/contact-nl.json';
import legal_nl from './nl/legal-nl.json';
import faq_nl from './nl/faq-nl';
import cookiesInfo_nl from './nl/cookies-info-nl.json';

import it from './it/it.json';
import contact_it from './it/contact-it.json';
import legal_it from './it/legal-it.json';
import faq_it from './it/faq-it';
import cookiesInfo_it from './it/cookies-info-it.json';

import pt from './pt/pt.json';
// import contact_pt from './pt/contact-pt.json';
// import legal_pt from './pt/legal-pt.json';
// import faq_pt from './pt/faq-pt';
import cookiesInfo_pt from './pt/cookies-info-pt.json';

import { getFromLocalStorage } from '../utils/browser-storage';

// This is the available languages table.
// new languages should be added here as well.
export const languages = [
  {
    title: 'English',
    iso: 'en',
    index: 0,
  },
  {
    title: 'Deutsch',
    iso: 'de',
    index: 1,
  },
  {
    title: 'Francais',
    iso: 'fr',
    index: 2,
  },
  {
    title: 'Nederlands',
    iso: 'nl',
    index: 3,
  },
  {
    title: 'Italiano',
    iso: 'it',
    index: 4,
  },
  // {
  //   title: 'Polski',
  //   iso: 'pl',
  //   index: 5,
  // },
  {
    title: 'Espanol',
    iso: 'es',
    index: 6,
  },
  // {
  //   title: 'Svenska',
  //   iso: 'sv',
  //   index: 7,
  // },
  {
    title: '中文',
    iso: 'zh',
    index: 8,
  },
  {
    title: 'Português',
    iso: 'pt',
    index: 9,
  },
];

export const translations = {
  en: {
    ...en,
    ...contact_en,
    ...legal_en,
    ...faq_en,
    ...cookiesInfo_en,
    ...agb_en,
    ...privacy_en,
    ...about_us_en,
  },
  de: {
    ...de,
    ...contact_de,
    ...legal_de,
    ...faq_de,
    ...cookiesInfo_de,
    ...agb_de,
    ...privacy_de,
    ...about_us_de,
  },
  fr: {
    ...fr,
    ...contact_en,
    ...legal_en,
    ...faq_en,
    ...cookiesInfo_en,
    ...agb_en,
    ...privacy_fr,
  },
  es: {
    ...es,
    ...contact_es,
    ...legal_es,
    ...faq_es,
    ...cookiesInfo_es,
    ...agb_en,
    ...privacy_en,
  },
  zh: {
    ...zh,
    ...contact_en,
    ...legal_en,
    ...faq_en,
    ...cookiesInfo_en,
    ...agb_en,
    ...privacy_en,
  },
  nl: {
    ...nl,
    ...contact_nl,
    ...legal_nl,
    ...faq_nl,
    ...cookiesInfo_nl,
    ...agb_en,
    ...privacy_en,
  },
  it: {
    ...it,
    ...contact_it,
    ...legal_it,
    ...faq_it,
    ...cookiesInfo_it,
    ...agb_en,
    ...privacy_en,
  },
  pt: {
    ...pt,
    ...contact_en,
    ...legal_en,
    ...faq_en,
    ...cookiesInfo_pt,
    ...agb_en,
    ...privacy_en,
  },
};

/**
 * Check whether the translation for the specified language exist or not
 * @param  {string} langCode The language code (en, de, fr) to check
 * @return {boolean} Returns true if language is supported else false.
 */
export function isLanguageSupported(langCode) {
  let exists = false;
  for (let i = 0; i < languages.length; i++) {
    const language = languages[i];
    if (language.iso === langCode) {
      exists = true;
    }
  }
  return exists;
}

export function getAppLanguage() {
  // NOTE: In our app we use only 2 letters language descriptions
  //
  // Try to get the language from the local storage
  let languageFromLocalStorage = getFromLocalStorage('language');
  if (languageFromLocalStorage) {
    return languageFromLocalStorage;
  }

  // If no language is saved in the local storage get the browsers preferred language
  // Appsignal has reported quite a few bugs where the app wanted to access the substring
  // from a value which is undefined.
  if (navigator) {
    if (navigator.language) {
      if (isLanguageSupported(navigator.language.substring(0, 2))) {
        return navigator.language.substring(0, 2);
      }
    }

    if (navigator.userLanguage) {
      if (isLanguageSupported(navigator.userLanguage.substring(0, 2))) {
        return navigator.userLanguage.substring(0, 2);
      }
    }
  }
  // By default return english
  return 'en';
}

// By default this function return en_US
export function getLocaleWithCountryCode(language) {
  switch (language) {
    case 'de':
      return 'de_DE';

    case 'nl':
      return 'nl_NL';

    case 'fr':
      return 'fr_FR';

    case 'it':
      return 'it_IT';

    case 'pl':
      return 'pl_PL';

    case 'es':
      return 'es_ES';

    case 'sv':
      return 'sv_SE';

    case 'zh':
      return 'zh_CN';

    case 'pt':
      return 'pt_PT';

    default:
      return 'en_US';
  }
}
